var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-panel',[_c('y-form-cloner',{attrs:{"children":_vm.formFields},model:{value:(_vm.model.custom_fields),callback:function ($$v) {_vm.$set(_vm.model, "custom_fields", $$v)},expression:"model.custom_fields"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }